<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :handles2="handles2"
      label-width="120px"
    />
    <el-dialog
      v-dialogDrag
      :title="$t('elTable.oneNoOvercharge')"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      center
    >
      <el-form ref="form" :model="form" :rules="formRule" label-width="150px">
        <el-form-item :label="$t('elTable.oneNoOvercharge')" prop="resource">
          <!-- <el-form-item :label="$t('navbar.title')" prop="resource"> -->
          <el-radio-group v-model="form.resource">
            <el-radio :label="true">{{ $t('commonly.yes') }}</el-radio>
            <el-radio :label="false">{{ $t('commonly.not') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('enterpriseUser.setThreshold')" prop="input">
          <el-row>
            <el-input v-model="form.input" type="number" :placeholder="$t('commonly.inputContent')" style="width:200px;" />
            <span>{{ $t('commonly.element') }}</span>
          </el-row>
        </el-form-item>
      </el-form>
      <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
        <el-button @click="dialogVisible = false">{{ $t('commonly.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('commonly.determine') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Qiyeyonghu',
  data() {
    let radioVal = ''
    var checkRadio = (rule, value, callback) => {
      radioVal = value
      callback()
    }
    var check = (rule, value, callback) => {
    // value input框的数据
      if (radioVal) {
        const reg = /(^(\-|\+?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确数值'))
        }
      } else {
        callback()
      }
    }
    return {
      input: '',
      id: '',
      form: {
        resource: false,
        input: ''
      },
      formRule: {
        resource: [
          { required: true, message: '请选择一号多充' },
          { validator: checkRadio, trigger: 'change' }
        ],
        input: [
          // {required:true,message:"请输入阈值"},
          { validator: check, trigger: 'change' }
        ]
      },
      url: '/user/account/page?unit=true',
      columns: [
        {
          label: '用户所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '车牌号',
          prop: 'vehiclePlateNumbers'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '绑定标签',
          prop: 'label'
        },
        {
          label: '用户经验值',
          prop: 'accumulatePoints'
        },
        {
          label: '状态',
          prop: 'forzen',
          template: function(index, reocrd) {
            return reocrd.frozen
              ? "<div class='circle red'></div><span>冻结</span>"
              : "<div class='circle green'></div><span>正常</span>"
          }
        }
      ],
      handles2: {
        label: '一号多充',
        width: 100,
        btns: [
          {
            prop: 'moreCharging',
            permission: '',
            activeValue: true,
            inactiveValue: false,
            handle: (resp) => {
              const data = {
                id: resp.id
              }
              this.$store.dispatch('form/handle', {
                url: '/user/account/moreCharging',
                data: data,
                method: 'post',
                callback: resp => {
                  this.$refs.tableref.queryTable()
                }
              })
            }
          }
        ]
      },
      // 操作栏
      handles: {
        width: 350,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'user.enterprise.details',
            handle: (resp) => {
              this.$router.push({ path: './detailEnterprise', query: { data: resp.id }})
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'user.enterprise.update',
            handle: resp => {
              this.$router.push({ path: './reviseEnterpriseuser', query: { data: resp.id }})
            }
          },
          {
            label: '用户钱包',
            permission: 'user.enterprise.wallet',
            style: 'color:#00FF00',
            handle: (resp) => {
              this.$router.push({ path: './userWallet', query: { data: resp.id }})
            }
          },
          {
            label: '密码重置',
            permission: 'user.enterprise.Reset',
            url: '/user/account/resetPwd',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定将密码重置为888888？',
            before: (index, record) => {
              const p = {
                id: record.id
              }
              return p
            },
            handle: resp => {
              this.$notify({
                title: '成功',
                message: '重置密码成功',
                type: 'success'
              })
            }
          },
          {
            label: '冻结',
            permission: 'user.enterprise.frozen',
            style: 'color:red',
            getLabel: function(record) {
              return record.frozen ? '恢复' : '冻结'
            },
            url: '/user/account/frozen',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定执行本操作？',
            before: function(index, record) {
              const p = {
                id: record.id
              }
              return p
            },
            handle: (resp, o) => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '删除',
            permission: 'user.enterprise.delete',
            style: 'color:red',
            url: '/user/account',
            method: 'delete',
            isConfirm: true,
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                ids: arr
              }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      // 查询栏
      query: [
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'userName',
          placeholder: '请输入用户姓名'
        },
        {
          label: '归属企业',
          prop: 'orgName',
          placeholder: '请输入归属企业'
        },
        {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        },
        {
          label: '状态',
          prop: 'frozen',
          placeholder: '请选择状态',
          type: 'select',
          data: [
            {
              label: '正常',
              value: 'false'
            },
            {
              label: '冻结',
              value: 'true'
            }
          ]
        },
        {
          label: '一号多充',
          prop: 'moreCharging',
          placeholder: '请选择一号多充',
          type: 'select',
          data: [
            {
              label: '否',
              value: 'false'
            },
            {
              label: '是',
              value: 'true'
            }
          ]
        }
      ],
      // 操作按钮
      toolbar: [
        {
          label: '新增',
          permission: 'user.enterprise.add',
          type: 'primary',
          handle: res => {
            this.$router.push('./addEnterprise')
          }
        },
        {
          label: '下载模板',
          icon: 'el-icon-download',
          permission: 'user.enterprise.download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/user/account/import/template'
            $.fileDownload(url, {
              httpMethod: 'get',
              data: {
                token: window.localStorage.getItem('token')
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '模板下载失败',
                  type: 'error'
                })
              }
            })
          }
        },
        {
          label: '批量导入',
          icon: 'el-icon-upload2',
          permission: 'user.enterprise.Import',
          type: 'primary',
          isUpload: true,
          url: HOST + '/user/account/import',
          method: 'post',
          option: {
            loading: false,
            headers: {
              token: window.localStorage.getItem('token'),
              companyId: window.localStorage.getItem('curCompanyId')
            },
            beforeUpload: (file) => {
              this.toolbar[2].option.loading = true
            },
            onSuccess: (response, file, fileList) => {
              this.toolbar[2].option.loading = false
              if (!response.code) {
                this.$refs.tableref.queryTable()
                this.$notify({
                  title: '成功',
                  message: '批量导入成功',
                  type: 'success'
                })
                return
              }
              this.$notify({
                title: '失败',
                message: response.message,
                type: 'error'
              })
            },
            onError: (err, file, fileList) => {
              this.toolbar[2].option.loading = false
              this.$notify({
                title: '失败',
                message: '批量导入失败',
                type: 'error'
              })
            },
            onProgress: (event, file, fileList) => {}
          }
        }
      ],
      dialogVisible: false
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    async submit() {
    // submit(){
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      const data = {
        id: this.id,
        moreCharging: this.form.resource,
        moreChargingMoney: this.form.input
      }
      this.$store.dispatch('form/handle', {
        url: '/user/account/moreCharging',
        data: data,
        method: 'post',
        callback: resp => {
          this.dialogVisible = false
          this.$refs.tableref.queryTable()
          this.form.resource = false
          this.form.input = ''
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/userManagement/enterpriseuser.vue